import { Guidance } from "./guidance-type";
import { Translatable } from '@icc/shared/helpers';

/** Typ produktu */
export class ShutterType {
    id: number;
    /** Nazwa */
    @Translatable({ model: 'ShutterTypes' })
    name: string;
    /** Opis */
    description: string;
    /** Zdjęcie */
    img: string;
    /** Żaluzja bez lameli */
    onlyCover: boolean;
    onlyShutter: boolean;
    /** Posiada lamele */
    hasProfiles: boolean;
    /** Pasujące profile */
    profiles: {
        id: number;
        /** Typ profilu */
        type: string;
    }[];
    /** Ma przypisane rodzaje montażu */
    hasMontageTypes: boolean;
    /** Domyślne prowadzenie */
    defaultGuidance: Guidance;
    /** Dostępne prowadzenie (skrajne i globalne) */
    availableGuidanceGlobal: Guidance[];
    /** Dostępne prowadzenie wspólne (wewn. zestawu) */
    availableGuidanceCommon: Guidance[];
    /** Czy może byc wykonywany otwór pod kabel (dodaje wybór strony sterowania przy zakupie samej skrzynki) */
    hasDriveCableHole: boolean;
    /** Nie bierz pod uwagę cennika rastrowego */
    ignorePriceRaster: boolean;
    /** Czy ma dostępne narożniki (90°) */
    availableCorners: boolean;

    /** Kolejność */
    order?: number;

    /** Czy ma zewnętrzną listwę tynkową */
    hasOutsidePlasterStopBead?: boolean;
    /** Czy ma wewnętrzną listwę tynkową */
    hasInsidePlasterStopBead?: boolean;
    /** Brak wyboru listwy tynkowej (domyślnie wybrana) */
    plasterStopBeadNoChoice?: boolean;
    /** Czy zewnętrzna listwa tynkowa ma automatycznie dobierany kolor */
    outerPlasterStripColorAuto?: boolean;
}
